import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ggi-32",
  "use": "icon-ggi-32-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ggi-32\">\n<path d=\"M4 12H6.61919C7.02704 12 7.39402 11.7523 7.54659 11.3741L9.00025 7.77022C9.35925 6.88019 10.6441 6.95783 10.8933 7.88461L13.1067 16.1154C13.3559 17.0422 14.6408 17.1198 14.9998 16.2298L16.4534 12.6259C16.606 12.2477 16.973 12 17.3808 12H20\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol